import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReactModal from 'react-modal';
import autobind from 'autobind-decorator';

import { NavLink } from 'react-router-dom';

// import EditImage from 'common/components/edit-image';
// import FieldFactory from 'common/components/field-factory';
import FieldFactory from 'client/shared/components/field-factory';
// import SongSelector from 'common/components/song-selector';

import EditImage from 'client/shared/components/edit-image/edit-image';

import MZDList from '../manage-lists/mzdlist-list';

@inject('documentStore','genreStore', 'songsStore', 'formStore')
@observer
class DocumentModal extends Component {
	constructor (props) {
		super(props);

		this.state = {
			modalIsOpen: false
		};

		/**
		 * This is where the document is either:
		 *      1. Passed in via the props, when editing an existing doc
		 *      2. A new document is created with a default document type that can also be passed in as a prop
		 */
		const { document=false, documentStore, documentType = 'ARTIST_FAQ' } = this.props;
		this.document = document || documentStore.newDocument({
			// _id: "id" + documentStore.documents.length + 1,
			type: documentType,
			// content: '',
			// title: ''
		});
		console.log(this.document)
	}

	render () {
		const {
			documentStore,
			buttonLabel = '',
			icon = 'pencil',
			buttonClassName = 'add-button button'
		} = this.props;

		return (
			<div className="cell shrink">
				<ReactModal
					appElement={ window.document.querySelector('#app') }
					className="modal-container"
					isOpen={ this.state.modalIsOpen }
					contentLabel="Edit Document"
					shouldCloseOnOverlayClick={ true }
					className={{
						base: 'modal',
						afterOpen: 'modal-after-open',
						beforeClose: 'modal-beforex`-close'
					}}
					overlayClassName={{
						base: 'modal-overlay',
						afterOpen: 'modal-overlay-after-open',
						beforeClose: 'modal-overlay-before-close'
					}}
				>
					<div className="modal-content" data-ta="documentModal">
						<div className="grid-x">
							<div className="cell">
								{ this.renderMainContent() }
							</div>
						</div>

						<div className="modal-button-group">
							<button
								className="button clear secondary"
								onClick={ this.handleCloseModal }
							>
								Close Modal
							</button>
							<button
								data-ta="saveDocumentBtn"
								className="button clear primary-color"
								onClick={ this.onClick }
							>
								Save
							</button>
						</div>
					</div>
				</ReactModal>

				<button
					data-ta="documentModalBtn"
					className={ buttonClassName }
					onClick={ this.handleOpenModal }
				>
					<span className={ `fas fa-${icon} padding-0` }></span> { buttonLabel }
				</button>
			</div>
		);
	}

	getField () {
		const { documentStore: store, formStore } = this.props;
		const document = this.document;
		const { _id: dataId } = document;

		return (props) => {
			const propsObj = { formStore, store };

			if (_.isEmpty(dataId) !== true) {

				Object.assign(propsObj, { dataId });
			}

			return (
				<FieldFactory item={ document } { ...props } { ...propsObj } />
			);
		}
	}

	renderMainContent () {
		const { documentStore, formStore } = this.props;
		const document = this.document;
		const Field = this.getField();

		return (
			<div className="grid-x grid-padding-x">
				<div className="cell small-12" data-ta="documentLabelInputContainer">
					<Field fieldKey="document.title" />
				</div>

				<div className="cell small-4">
					<Field fieldKey="document.content" />
					{/* <Field fieldKey="document.content" /> */}
				</div>
				<div className="cell small-8"></div>
			</div>
		);
	}

	@autobind
	onClick () {
		// This will trigger any component that accesses documentStore.documents to rerender
		this.document.save();
	}

	@autobind
	handleOpenModal () {
		this.setState({
			modalIsOpen: true
		});
	}

	@autobind
	handleCloseModal () {
		this.setState({
			modalIsOpen: false
		});
	}

	// @autobind
	// handleImageCrop (imgData) {
	// 	const { genreStore } = this.props;
	// 	const { _id } = this.getGenre();

	// 	if (_.isEmpty(_id)) {

	// 		genreStore.data.genre.set('imgData', imgData);
	// 		return;
	// 	}

	// 	genreStore.saveGenreArtwork({ _id, imgData }, {
	// 		silent: true,
	// 		onSuccess: this.handleCloseModal
	// 	});
	// }
}

export default DocumentModal;
